module.exports = __webpack_public_path__ + "aeb13bfe41abe46248da3334c5f1dacd.svg";